/* ==========================================================================
   pb-product.js — Galería (thumbs) + actualización de variante (precio, CTA).
   JS mínimo, sin dependencias. El precio viene pre-formateado desde Liquid.
   ========================================================================== */
(function () {
  'use strict';
  var section = document.querySelector('.pb-product');
  if (!section) return;

  /* ----- Galería: carrusel deslizable (swipe + flechas + puntos + thumbs) ----- */
  var gallery = section.querySelector('[data-pb-gallery]');
  if (gallery) {
    var track = gallery.querySelector('[data-pb-gallery-track]');
    var slides = track ? track.querySelectorAll('[data-pb-slide]') : [];
    var dots = gallery.querySelectorAll('[data-pb-dot]');
    var gThumbs = gallery.querySelectorAll('[data-pb-thumb]');
    var prev = gallery.querySelector('[data-pb-gallery-prev]');
    var next = gallery.querySelector('[data-pb-gallery-next]');

    if (track && slides.length > 1) {
      var goTo = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var current = function () {
        return Math.round(track.scrollLeft / track.clientWidth);
      };
      var sync = function () {
        var i = current();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        gThumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      };
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      gThumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 60); });
    }
  }

  /* ----- Variantes: actualizar precio / disponibilidad / sticky ----- */
  var dataEl = section.querySelector('[data-pb-variants]');
  var select = section.querySelector('[data-pb-variant-select]');
  if (!dataEl) return;

  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var priceEl = section.querySelector('.pb-price');
  var submit = section.querySelector('[data-pb-submit]');
  var stickyPrice = section.querySelector('[data-pb-sticky-price]');

  function renderPrice(v) {
    if (priceEl) {
      var html = '<div class="pb-price__main">';
      if (v.on_sale) html += '<s class="pb-price__was">' + v.compare + '</s>';
      html += '<span class="pb-price__now">' + v.price + '</span></div>';
      if (v.on_sale) html += '<span class="pb-price__pct">−' + v.pct + '%</span>';
      priceEl.innerHTML = html;
      priceEl.classList.toggle('is-sale', !!v.on_sale);
    }
    if (stickyPrice) stickyPrice.textContent = v.price;
  }

  function update(id) {
    var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    renderPrice(v);
    if (submit) {
      submit.disabled = !v.available;
      submit.textContent = v.available ? (submit.dataset.label || submit.textContent) : 'Agotado';
    }
  }

  if (select) {
    select.addEventListener('change', function () { update(this.value); });
  }
})();

/* ----- Slider antes/después (independiente de la buy box) ----- */
(function () {
  'use strict';
  var sliders = document.querySelectorAll('[data-pb-ba]');
  sliders.forEach(function (el) {
    var before = el.querySelector('[data-pb-ba-before]');
    var handle = el.querySelector('[data-pb-ba-handle]');
    var range = el.querySelector('[data-pb-ba-range]');
    if (!range || !before) return;
    function set(v) {
      before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      if (handle) handle.style.left = v + '%';
    }
    range.addEventListener('input', function () { set(this.value); });
    set(range.value);
  });
})();

/* ----- Ofertas por cantidad -----
   Cada tarjeta es una cantidad. El precio lo cobra la oferta de cantidad de la app COD, así que
   los % del tema y los de la app tienen que ser los mismos. Al elegir una tarjeta dejamos la
   cantidad puesta y, cuando el popup de la app aparece, marcamos ahí el mismo escalón: sin esto
   el cliente elegía 3 unidades arriba y el formulario abría en 1. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-pb-offers]');
  if (!wrap) return;

  function chosen() {
    var c = wrap.querySelector('.pb-offer-card__radio:checked');
    return c && c.getAttribute('data-pb-offer-qty');
  }

  function apply(qty) {
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.value = qty; });
    document.documentElement.setAttribute('data-pb-offer-qty', qty);
    paint();
  }

  /* El relleno del círculo se marca por clase: así no depende del soporte de :has() */
  function paint() {
    wrap.querySelectorAll('.pb-offer-card').forEach(function (card) {
      var r = card.querySelector('.pb-offer-card__radio');
      var on = !!(r && r.checked);
      card.classList.toggle('is-selected', on);
      var fill = card.querySelector('.pb-offer-card__fill');
      if (fill) fill.style.transform = on ? 'scale(1)' : 'scale(0)';
    });
  }

  /* El popup de la app monta sus propias tarjetas ("1 unidad", "2 unidades"...) fuera de nuestro
     DOM. Las reconocemos por el texto y descartamos las nuestras por la clase. */
  /* El popup de la app monta sus propios escalones en el mismo orden que los nuestros.
     Los ubicamos por su grupo de radios y marcamos el que corresponde por posición. */
  var total = wrap.querySelectorAll('[data-pb-offer-qty]').length;

  function syncPopup() {
    var qty = chosen();
    if (!qty) return;
    var groups = {};
    document.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (r.closest('[data-pb-offers]')) return;
      var k = r.name || '_';
      (groups[k] = groups[k] || []).push(r);
    });
    Object.keys(groups).forEach(function (k) {
      var g = groups[k];
      if (g.length !== total) return;
      var target = g[parseInt(qty, 10) - 1];
      if (!target || target.checked) return;
      target.click();
    });
  }

  wrap.addEventListener('change', function (e) {
    var r = e.target.closest('[data-pb-offer-qty]');
    if (r) {
      apply(r.getAttribute('data-pb-offer-qty'));
      document.querySelectorAll('[data-pb-synced]').forEach(function (n) {
        n.removeAttribute('data-pb-synced');
      });
    }
  });

  var checked = wrap.querySelector('.pb-offer-card__radio:checked');
  if (checked) apply(checked.getAttribute('data-pb-offer-qty'));

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      clearTimeout(syncPopup._t);
      syncPopup._t = setTimeout(syncPopup, 400);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Fecha de la nota de urgencia. Liquid ya la imprime, pero Shopify cachea la
   página: si el HTML queda guardado, mañana seguiría diciendo la de hoy. Se
   reescribe con la fecha del dispositivo, que además es la zona del cliente. */
(function () {
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun',
               'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var d = new Date();
  var txt = d.getDate() + ' ' + MESES[d.getMonth()];
  document.querySelectorAll('[data-pb-hoy]').forEach(function (n) {
    n.textContent = txt;
  });
})();
